import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=6c5bdaef&scoped=true"
var script = {}
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=6c5bdaef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bdaef",
  null
  
)

export default component.exports